import { useCallback } from 'react';
import { usePlacingPluginContext } from '../../placing-plugin/PlacingPluginContext';
import { usePanels } from '../../../../../panels/usePanels';
import { PluginDataManagementSvg } from '../icons';
import { PluginTypes } from '../../../../../../types/enums/PluginTypes';

export const useOnAddDataManagementPlugin = () => {
  const { setPlacingPlugin } = usePlacingPluginContext();
  const { forceCloseAllPanels } = usePanels();

  const onAdd = useCallback(() => {
    forceCloseAllPanels();
    setPlacingPlugin({
      pluginImage: <PluginDataManagementSvg />,
      type: PluginTypes.DATA_MANAGEMENT,
    });
  }, [forceCloseAllPanels, setPlacingPlugin]);

  return onAdd;
};
